<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Repair Code Grade Mapping' }}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Repair code grade mapping</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-container-grade-repair-code-search
        class="search-bar"
        [searchTextForm]="filterFormGroup.controls.searchTextForm"></app-container-grade-repair-code-search>
    </div>
  </div>
  <app-container-grade-repair-code-filters [filterFormGroup]="filterFormGroup"></app-container-grade-repair-code-filters>
  <app-container-grade-repair-code-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-container-grade-repair-code-grid>
</form>
